import { useQuery } from '@tanstack/react-query';
import { AGENT_REVIEW_KEY } from '../utils/query-keys';
import type {
  GetAgentReviewCountsData,
  GetAgentReviewsData,
} from '../types/agentReview';
import * as agentReviewService from '../services/agentReviewServices';

export const useAgentReviews = (data: GetAgentReviewsData) =>
  useQuery({
    queryKey: [...AGENT_REVIEW_KEY, 'agentReviews'],
    queryFn: () => agentReviewService.getAgentReviews(data),
  });

export const useAgentReviewCounts = (data: GetAgentReviewCountsData) =>
  useQuery({
    queryKey: [...AGENT_REVIEW_KEY, 'agentReviewCounts'],
    queryFn: () => agentReviewService.getAgentReviewCounts(data),
  });
